module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/tides/tide-detail/tide-detail.component.sass
// module id = ./src/app/tides/tide-detail/tide-detail.component.sass
// module chunks = main